import { render } from "./MemoModal.vue?vue&type=template&id=282d2e62&ts=true"
import script from "./MemoModal.vue?vue&type=script&lang=ts"
export * from "./MemoModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__